module.exports = __webpack_public_path__ + "img/clue_chromebook_login2.bed8044f.png";